import React from 'react';
import { Grid, Skeleton } from '@mui/material';
import PropTypes from 'prop-types';
import { useDevice } from '../../../hooks/useResponsive';
import ProductCard from '../../Products/productCard';

export default function VehiclesByCategory({ vehicles, categoryLoading }) {
  const { isMobile } = useDevice();

  // const filteredVehicles = vehicles?.filter((vehicle) => vehicle.isSold === false);
  const visibleVehicles = isMobile ? vehicles?.slice(0, 6) : vehicles?.slice(0, 6);

  const skeletonCount = isMobile ? 4 : 8; // number of shimmer cards

  return (
    <Grid
      container
      direction="row"
      mt={2}
      spacing={2}
      px={!isMobile && 1}
      pb={!isMobile && 1}
      pt={!isMobile && '-5px !important'}
      backgroundColor={!isMobile && '#141414'}
    >
      {categoryLoading
        ? Array.from({ length: skeletonCount }).map((_, index) => (
            <Grid item xs={6} md={6} lg={6} key={index}>
              <Skeleton variant="rectangular" height={220} sx={{ borderRadius: 2 }} />
              <Skeleton variant="text" sx={{ mt: 1 }} width="80%" />
              <Skeleton variant="text" width="60%" />
            </Grid>
          ))
        : visibleVehicles?.map((vehicle, index) => (
            <Grid item xs={6} md={6} lg={6} key={vehicle.id || index} sx={{ pt: !isMobile && '12px !important' }}>
              <ProductCard product={vehicle} />
            </Grid>
          ))}
    </Grid>
  );
}

VehiclesByCategory.propTypes = {
  vehicles: PropTypes.any,
  categoryLoading: PropTypes.bool,
};
